import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const IndustrialWastewaterTreatmentPlants: React.FC = () => {
  return (
    <>
      <PageHeader customClass='bg-breadcrumb-om' title="Industrial Wastewater Treatment Plants – O&M Services" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Industrial Wastewater Treatment Plants – O&M Services</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Wastewater treatment is not just a regulatory requirement — it is a key component of an industry's sustainability strategy. At Wasser Technochem (India) Ltd., we deliver specialized Operation & Maintenance (O&M) services for Effluent Treatment Plants (ETPs) and Zero Liquid Discharge (ZLD) systems, ensuring that your facility remains compliant, efficient, and environmentally responsible.</p>
              <p>Our excellence in execution is demonstrated by a PQ Scorecard consistently above 90% during our 3-year tenure (2013–2015) for operating water utility and cooling tower systems at Vedanta – HZL (Hydro-2 Chanderiya). With over two decades of experience in textile, chemical, food processing, and metal industries, we manage complex wastewater streams with precision and performance reliability.</p>

              <h3 className="mb-4">Scope of Services</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <p><i className="fa fa-clock text-primary me-2"></i>Round-the-clock plant operation and performance logging</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-flask text-primary me-2"></i>Effluent sampling and lab testing (pH, TSS, BOD, COD, TDS)</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-tint text-primary me-2"></i>Coagulant, flocculant, and pH correction chemical dosing</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-recycle text-primary me-2"></i>Sludge handling (filter press, centrifuge, decanter)</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-cogs text-primary me-2"></i>Operation of MBBR, SBR, MBR technologies</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-droplet text-primary me-2"></i>ZLD operation including RO, MEE, and ATFD</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-chart-line text-primary me-2"></i>Compliance management and online analyzer operation</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-bell text-primary me-2"></i>Remote alert systems and troubleshooting support</p>
                </div>
              </div>

              <h3 className="mb-4">Coverage</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-palette text-primary me-2"></i>Textile ETPs</h5>
                      <p>ETPs for textile dyeing and finishing units</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-pills text-primary me-2"></i>Pharma & Chemical</h5>
                      <p>Pharma and chemical plant wastewater systems</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-fire text-primary me-2"></i>ZLD Systems</h5>
                      <p>Multi-effect Evaporator (MEE) and ATFD-based ZLD units</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-industry text-primary me-2"></i>Power & Steel</h5>
                      <p>High TDS wastewater handling from power and steel industries</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-sync text-primary me-2"></i>Recycling Systems</h5>
                      <p>Pre-treatment and polishing plants for recycling</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Full Compliance</h5>
                  <p>Full compliance with CPCB, SPCB, and industrial discharge norms</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Optimized Usage</h5>
                  <p>Optimized chemical and energy usage</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Environmental Impact</h5>
                  <p>Reduced environmental footprint through recycling and reuse</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Expert Operations</h5>
                  <p>Trained operators with experience in industry-specific waste streams</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Real-time Monitoring</h5>
                  <p>Real-time monitoring and monthly performance analytics</p>
                </div>
              </div>

              <h3 className="mb-4">Why WTIL?</h3>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-tachometer-alt text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Large Scale Operations</h5>
                      <p className="mb-0">Running ETPs/ZLDs up to 2 MLD capacity across India</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-flask text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Chemical Integration</h5>
                      <p className="mb-0">In-house supply of SANYOL® WT ETP/STP chemicals</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-chart-line text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Proven Results</h5>
                      <p className="mb-0">Proven results in effluent load reduction and reuse optimization</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-file-alt text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>SOP-Driven Maintenance</h5>
                      <p className="mb-0">SOP-driven maintenance with emergency response plans</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-handshake text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>EHS Collaboration</h5>
                      <p className="mb-0">Collaboration with EHS teams for audits and documentation</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default IndustrialWastewaterTreatmentPlants;
